import { useMemo } from 'react';
import { dictDeserializer } from '../Helpers/CultureHelpers';
import { TranslationDictionary } from '../Models/TranslationDictionary';

export const useTranslation = (
    translationJson: string
): TranslationDictionary => {
    return useMemo(() => {
        const translationDictionary = dictDeserializer(translationJson);

        const translations: TranslationDictionary = {};
        Object.keys(translationDictionary).forEach(
            (key) => (translations[key] = translationDictionary[key] || key)
        );

        return translations;
    }, [translationJson]);
};
